import * as Select from '@studio/design-system/select';
import { Protocol as M_Protocol, toProtocol } from '@studio/models/video';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Props } from './types.js';
import { Lang } from '#~/video/index.js';

/** Video `<Protocol>` component. */
export const Protocol = ({ protocol, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextProtocol = toProtocol(nextValue);

    if (nextProtocol && nextProtocol !== protocol.value) {
      protocol(nextProtocol);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={protocol.value}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() =>
            [M_Protocol.NDI, M_Protocol.RTSP].map((µ) => (
              <Select.Item key={µ} value={µ}>
                {Lang.protocol[µ]}
              </Select.Item>
            ))
          ).current
        }
      </Select.Content>
    </Select.Root>
  );
};
